var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    className: "ionicon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Marker") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.558,29 L4,29 C3.448,29 3,28.553 3,28 L3,20.442 C3,19.782 3.268,19.135 3.734,18.67 L21.311,1.093 C22.766,-0.361 25.134,-0.362 26.589,1.093 L26.589,1.093 L30.907,5.411 C32.361,6.866 32.361,9.233 30.907,10.688 L13.33,28.266 C12.858,28.739 12.228,29 11.558,29 Z M5,27 L11.558,27 C11.693,27 11.82,26.947 11.915,26.853 L29.493,9.275 C30.168,8.6 30.168,7.501 29.493,6.826 L25.175,2.508 C24.5,1.834 23.403,1.833 22.725,2.508 L5.148,20.084 C5.054,20.178 5,20.309 5,20.442 L5,27 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,32 C0.744,32 0.488,31.902 0.293,31.707 C-0.098,31.316 -0.098,30.684 0.293,30.293 L3.293,27.293 C3.684,26.902 4.316,26.902 4.707,27.293 C5.098,27.684 5.098,28.316 4.707,28.707 L1.707,31.707 C1.512,31.902 1.256,32 1,32 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31,32 L1,32 C0.448,32 0,31.553 0,31 C0,30.447 0.448,30 1,30 L31,30 C31.553,30 32,30.447 32,31 C32,31.553 31.553,32 31,32 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.147,28.878 C11.685,28.878 11.27,28.556 11.17,28.086 C10.397,24.451 7.548,21.604 3.914,20.831 C3.374,20.716 3.029,20.185 3.144,19.644 C3.259,19.105 3.789,18.762 4.33,18.873 C8.736,19.811 12.188,23.263 13.126,27.669 C13.241,28.209 12.897,28.74 12.356,28.856 C12.286,28.871 12.216,28.878 12.147,28.878 Z",
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.8c9e6ca5bf1c2f85dcf79d06162b824d.svg";
export { ForwardRef as ReactComponent };